import { Component, Input } from '@angular/core'

import { DeviceSensor } from '@shared/models/sensor.model'

@Component({
  selector: 'lin-report-by-sensor-section',
  template: `
    <lin-layout-section title="{{ sensor.sensorId | macAddress }} ({{ sensor.label || '-' }})">
      <ng-content></ng-content>
    </lin-layout-section>
  `,
  styles: [
    `
      :host ::ng-deep .section {
        padding: 0 5px 28px;
      }

      :host ::ng-deep .linxio-table .mat-mdc-header-row:first-child .mat-mdc-header-cell {
        min-height: 50px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        border-bottom: 2px solid var(--primary-border-color);
      }
    `,
  ],
  standalone: false,
})
export class ReportBySensorSectionComponent {
  @Input() sensor: DeviceSensor
}
